/**
 * Bootstrap our clientside webpack entry...
 * Super simple but gives us a framework controlled entrypoint
 *
 * @author Nick Dreckshage <ndreckshage@wayfair.com>
 * @author Luke Reisch <lreisch@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */
/* eslint-env browser */
import domReady from 'domready';
import {loadableReady} from '@loadable/component';

export const setWebpackPublicPath = publicPath => {
  if (publicPath) {
    // cannot be window. or it doesnt work...
    // eslint-disable-next-line no-undef, camelcase
    __webpack_public_path__ = publicPath;

    if (process.env.NODE_ENV === 'development') {
      if (!publicPath.startsWith('http://localhost')) {
        // eslint-disable-next-line no-console
        console.log(
          '%cNot using localhost assets in development!',
          'background: yellow; color: black; font-size: large; font-weight: bold'
        );
      } else {
        // eslint-disable-next-line no-console
        console.log(
          '%cLocalhost development enabled.',
          'background: green; color: white; font-size: large; font-weight: bold'
        );
      }

      // eslint-disable-next-line no-console
      console.log(
        `For localhost development information, please see: https://docs.csnzoo.com/frontend/javascript/recipes/decoupling/localhost-dev-vm-backend/`
      );
    }
  }
};

export default function bootstrapClient(key) {
  if (!window.WEBPACK_PUBLIC_PATH_INITIALIZED) {
    setWebpackPublicPath(window.WEBPACK_PUBLIC_PATH);
    window.WEBPACK_PUBLIC_PATH_INITIALIZED = true;
  }

  return new Promise(domReady).then(() =>
    loadableReady(() => {}, {namespace: key}).then(
      () => window.WEBPACK_ENTRY_DATA[key]
    )
  );
}
